export const meau = [
  {
    mainLabel: '个人中心',
    mainVal: -1,
    menus: [
      {
        value: -1,
        path: '/my-center',
        baseProject: 'next',
      },
    ],
  },

  {
    mainLabel: '询价管理',
    mainVal: 1,
    menus: [
      {
        label: '开始询价',
        value: 22,
        path: '/my-inquiry/replace',
        baseProject: 'next',
      },
      {
        label: '我的询价',
        value: 23,
        path: '/my-price',
        baseProject: 'next',
      },
      {
        label: '我的项目',
        value: 24,
        path: '/my-project',
        baseProject: 'next',
      },
    ],
  },

  {
    mainLabel: '交易管理',
    mainVal: 2,
    menus: [
      {
        label: '我的订单',
        value: 15,
        path: '/my-order',
        baseProject: 'next',
      },
      {
        label: '待办事项',
        value: 21,
        path: '/my-todo',
        baseProject: 'next',
      },
    ],
  },

  {
    mainLabel: '资产管理',
    mainVal: 3,
    menus: [
      {
        label: '我的收藏夹',
        value: 16,
        path: '/my-collect',
        baseProject: 'next',
      },
      {
        label: '我的恐龙蛋',
        value: 14,
        path: '/my-egg',
        baseProject: 'next',
      },
      {
        label: '我的优惠券',
        value: 17,
        path: '/my-coupon',
        baseProject: 'next',
      },

      {
        label: '会员俱乐部',
        value: 10,
        path: '/my/personal/vip',
        baseProject: 'old',
      },
    ],
  },

  {
    mainLabel: '账户设置',
    mainVal: 4,
    menus: [
      {
        label: '认证中心',
        value: 19,
        path: '/my/personal/accountSetting',
        baseProject: 'old',
      },
      {
        label: '工作求职',
        value: 25,
        path: '/my-work',
        baseProject: 'next',
      },
      {
        label: '收货地址',
        value: 18,
        path: '/my-address',
        baseProject: 'next',
      },
      // {
      //     label: '个人信息',
      //     value: 1,
      //     path: '/my-center',
      //     baseProject: 'next'
      // },
      {
        label: '个人信息',
        value: 7,
        path: '/my-information',
        baseProject: 'next',
      }, // my-information
      {
        label: '我的消息',
        value: 13,
        path: '/my-message',
        baseProject: 'next',
      },
    ],
  },

  {
    mainLabel: '服务中心',
    mainVal: 5,
    menus: [
      {
        label: '帮助中心',
        value: 12,
        path: '/help/questionTypeDetail/1',
        baseProject: 'old',
      },
    ],
  },
]
